import React from 'react'
import c from 'classnames'

import * as F from 'discada/dist/Form'
import { initialAdd } from 'reducers/quoteReducers'

import Collection from 'components/widgets/Collection'

export function Add({ item, editValue, index, usingMdrive }) {
  return (
    <div className="quote-config-collection-addition quote-config-with-description">
      <F.TextField
        label="Product"
        value={item.name}
        onChange={({ target }) => editValue(index, 'name', target.value)}
      />

      <div className="field-set">
        <F.TextField
          size="small"
          type="number"
          label="Cost"
          min={0}
          value={item.cost}
          onChange={({ target }) =>
            editValue(index, 'cost', parseFloat(target.value))
          }
        />
        <F.TextField
          size="small"
          type="number"
          label="Retail Price"
          min={0}
          value={item.retail}
          onChange={({ target }) =>
            editValue(index, 'retail', parseFloat(target.value))
          }
        />
        <F.TextField
          size="small"
          type="number"
          min={0}
          label="Selling Price"
          value={item.price}
          onChange={({ target }) =>
            editValue(index, 'price', parseFloat(target.value))
          }
        />
      </div>

      <F.TextAreaField
        size="small"
        label="Description"
        className="addition-description"
        value={item.description}
        onChange={({ target }) => editValue(index, 'description', target.value)}
      />

      <div className="checkbox-field-set">
        <F.CheckboxField
          size="small"
          label="Show as available in Quote"
          checked={item.show || false}
          onChange={e => {
            editValue(index, 'show', e.target.checked)

            if (!e.target.checked) editValue(index, 'include', false)
          }}
        />
        <F.CheckboxField
          size="small"
          label="Include in Quote pricing"
          checked={item.include || false}
          disabled={!item.show}
          onChange={e => {
            editValue(index, 'include', e.target.checked)
          }}
        />
        {!usingMdrive && (
          <F.CheckboxField
            size="small"
            label="Required Purchase"
            checked={item.required || false}
            disabled={!item.show}
            onChange={e => {
              editValue(index, 'required', e.target.checked)
            }}
          />
        )}
      </div>
    </div>
  )
}

export default function Additions({
  items,
  addItem,
  removeItem,
  editValue,
  hideHelp,
  hideRemove,
  usingMdrive,
}) {
  return (
    <section className="quote-fees">
      <h3>Other Additions</h3>
      {!hideHelp && (
        <article className="message is-info is-small">
          <div className="message-body ">Lorem ipsum...</div>
        </article>
      )}
      {['additions'].map(s => (
        <Collection
          key={s}
          hideRemove={hideRemove}
          className={c(
            'quote-config-collection',
            `quote-config-collection-${s}`,
          )}
          items={items}
          addItem={addItem(s, { ...initialAdd })}
          removeItem={removeItem(s)}
          addButtonLabel="Add Addition"
          itemRenderer={(item, index, items) => (
            <Add
              {...{ item, index, items, usingMdrive }}
              editValue={editValue(s)}
            />
          )}
        />
      ))}
    </section>
  )
}
